import { DxTooltipModule, DxToolbarModule, DxAccordionModule, DxNumberBoxModule, DxGanttModule, DxAutocompleteModule, DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxDateBoxModule, DxDropDownBoxModule, DxDropDownButtonModule, DxPopupModule, DxRangeSliderModule, DxScrollViewModule, DxSelectBoxModule, DxSliderModule, DxTagBoxModule, DxTemplateModule, DxTextAreaModule, DxTextBoxModule, DxTreeListModule, DxTreeViewModule, DxFileUploaderModule } from 'devextreme-angular';
import { ProjectAttachedDocumentModule } from 'src/app/shared/project-attached-document/project-attached-document.module';
import { CreateUpdateTaskModule } from '../create-update-task/create-update-task.module';
import { SharedDatagridModule } from '../shared-datagrid/shared-datagrid.module';
import { MemorizedTaskModule } from '../memorized-task/memorized-task.module';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { TaskListComponent } from './task-list.component';
import { MdbGlobalModule } from '../mdb-global.module';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [
    TaskListComponent
  ],
  imports: [
    CommonModule,
    // TaskListRoutingModule,
    MdbGlobalModule,
    DxAccordionModule,
    DxButtonModule,
    DxTextBoxModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxDateBoxModule,
    DxAutocompleteModule,
    DxCheckBoxModule,
    DxDataGridModule,
    DxPopupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxRangeSliderModule,
    DxTemplateModule,
    DxTagBoxModule,
    DxNumberBoxModule,
    DxSliderModule,
    DxDropDownButtonModule,
    CreateUpdateTaskModule,
    DxTextAreaModule,
    MemorizedTaskModule,
    SharedDatagridModule,
    DxGanttModule,
    DxToolbarModule,
    ProjectAttachedDocumentModule,
    DxTooltipModule,
    DxFileUploaderModule,
  ],
  exports: [
    TaskListComponent,
    MdbGlobalModule,
    DxAccordionModule,
    DxButtonModule,
    DxTextBoxModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxDateBoxModule,
    DxAutocompleteModule,
    DxCheckBoxModule,
    DxDataGridModule,
    DxPopupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxRangeSliderModule,
    DxTemplateModule
  ],
  schemas: [NO_ERRORS_SCHEMA]

})
export class TaskListModule { }
